"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysOfWeekIndexList = void 0;
const types_1 = require("../types");
const getDaysOfWeekIndexList = () => {
    return [
        types_1.DAY_INDEX.monday,
        types_1.DAY_INDEX.tuesday,
        types_1.DAY_INDEX.wednesday,
        types_1.DAY_INDEX.thursday,
        types_1.DAY_INDEX.friday,
    ];
};
exports.getDaysOfWeekIndexList = getDaysOfWeekIndexList;
//# sourceMappingURL=getDaysOfWeekIndexList.js.map